export default {
	connectTitle: 'Connect to access trackers',
	mailPlaceholder: 'Mail',
	passwordPlaceholder: 'Password',
	connectError: 'Error during connection',
	connectButton: 'Sign in',
	selectTrackers: 'Select a tracker',
	discoverButton: 'Discover',
	zoomIn: 'Zoom in',
	zoomOut: 'Zoom out',
	pdfDownload: 'Download pdf',
	docDownload: `Download analysis`,
	watchVideo: 'Our methodology',
	howToRead: 'Legend',
	otherTrackers: 'Other trackers',
	signOut: 'Log off',
	discoverVerbatim: 'See verbatim comments',
	goodPractice: 'Best practice',
	priority: 'Priority',
	weakness: 'Weak signal',
	strength: 'Key strength',
	contactUs: 'Contact us',
	back: 'Go back',
	titles: {
		login: 'KPAM - Trackers',
		trackers: 'KPAM - Trackers',
		tracker: 'KPAM - Trackers',
		zoom: 'KPAM - Trackers',
		verbatim: 'KPAM - Trackers'
	},
	positiveImpact: {
		title: 'Positive impact',
		text: `A measurement of the intensity of the speech from the Promoters (the wow effect)`
	},
	averageSatisfaction: {
		title: 'Average satisfaction',
		text: `The average satisfaction of all customers (it shows how the company is performing today on each touchpoint)`
	},
	negativeImpact: {
		title: 'Negative impact',
		text: "A measurement of the intensity of the speech from the Detractors (the intensity of their frustrations)"
	},
	occurrence: {
		title: "Occurrence",
		text: "The percentage of customers who expressed an opinion on the touchpoint"
	},
	prioritySite: {
		title: "Priority",
		text: "High occurrence, poor average satifaction with high improvement potential"
	},
	weaknessCaption: {
		title: "Weak signal",
		text: "Low occurrence but strong negative impact"
	},
	strengthCaption: {
		title: "Key strength",
		text: "High occurrence and high average satisfaction"
	},
	goodPracticeCaption: {
		title: "Best practice",
		text: "Low occurrence but strong positive impact"
	},
	bddf: {
		title: "BDDF (détail des initiales à indiquer)"
	},
	bpf: {
		title: "BPF (détail des initiales à indiquer)"
	},
	risingOccurence: {
		title: "Increasing occurrence"
	},
	stableOccurrence: {
		title: "Stable occurrence"
	},
	fallingOccurrence: {
		title: "Decreasing occurrence"
	},
	badNavigator: `Trackers can't be opnened!
	To see it and all features, please update your browser.`
};